// src/app/services/toast.service.ts

import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

export type ToastType = 'success' | 'error' | 'info' | 'warn';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private messageService: MessageService) {}

  /**
   * Affiche un toast via PrimeNG (visible dans p-toast du app.component).
   */
  show(message: string, type: ToastType = 'info') {
    const summary = type === 'success' ? 'Succès' : type === 'error' ? 'Erreur' : type === 'warn' ? 'Attention' : 'Info';
    this.messageService.add({
      severity: type,
      summary,
      detail: message,
      life: type === 'error' ? 8000 : 5000
    });
  }
}
